import { EducationLevel } from 'services/api/types';

export const tabsConfig: { key: EducationLevel; name: string }[] = [
  {
    key: EducationLevel.Noo,
    name: '1-4 класс',
  },
  {
    key: EducationLevel.Ooo,
    name: '5-9 класс',
  },
  {
    key: EducationLevel.Soo,
    name: '10-11 класс',
  },
];
